import React from "react";

import { ReactComponent as PICOIcon } from "../../../../assets/svg/pico_icon.svg";
import { ReactComponent as BackIcon } from "../../../../assets/svg/arrow_left.svg";

import styles from "./Guide.module.scss";
type Props = {
  onBack: () => void;
};

const Guide: React.FC<Props> = ({ onBack }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.headerText}>ヒント機能PICO(ピコ)とは？</h2>
        <div className={styles.picoContainer}>
          <div className={styles.picoDetails}>
            授業中の「どう進めよう？」というお悩みを解決する先生専用の授業ナビゲーターAIだよ。
            生徒の興味を引く話題づくりや対話を深めるためのアイデアを提案するよ!
          </div>
          <PICOIcon height={115} width={115} />
        </div>
        <h2 className={styles.headerText}>例えばどんなヒントが出るの？</h2>
        <div className={styles.tags}>
          先生や生徒の興味・関心を <span>デザイン、食べ物、地域</span>
          と入れたときの導入トークアイデアは…
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.titleSection}>
          <p className={styles.title}>vol.1 Lesson00｢未来をつくる３つの力｣</p>
          <p className={styles.description}>
            自分の思うかっこいい大人や、AI・ロボットにはできない、｢人にしかできないこと｣とはなにかを考えるLesson
          </p>
        </div>
        <div className={styles.bodySection}>
          <p className={styles.header}>
            ①シャンプーボトルの“目印”/②食品ロス削減コンビニ/③公共施設の手すりの工夫
          </p>
          <div className={styles.descriptionContainer}>
            <p>【①シャンプーボトルの“目印”】</p>
            <p>
              シャンプーとリンス、目をつぶって触ったときに見分けづらいって思ったことない？
              それを解決したのが、シャンプーボトルの“ギザギザ”マーク。実は「目が見えにくい人にもわかるように」っていう工夫なんだよ。気づいた人の優しい気づきが、すごい発明につながってる。（出典：〇〇工業会/〇〇紹介）
            </p>
          </div>
          <div className={styles.descriptionContainer}>
            <p>【②食品ロス削減コンビニ】</p>
            <p>
              大手コンビニエンスストアでは、消費期限が近いお弁当やおにぎりを店頭で割引販売する取り組みや、キャッシュカードで買うと5％分のポイントがつく取り組みがあるんだって。「もったいない」って気づきをちゃんと仕組みに変えてるって、すごいよね。（出典：〇〇サステナビリティレポート）
            </p>
          </div>
          <div className={styles.descriptionContainer}>
            <p>【③公共施設の手すりの工夫】</p>
            <p>
              実は、子どもと大人の両方が使いやすいように、手すりを2段にする工夫が、公共施設や駅などで広まりつつあるんだ。たとえばある自治体では、「上段80cm/下段60cm」といった設計を推奨しているところもあるよ。気づかなきゃスルーしちゃうけど、こういう“気づきを実現する”って、すごいよね。（出典：〇〇市
              バリアフリー整備マニュアル）
            </p>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        先生の考えや、生徒の様子を入力していただくことで、生徒の状況に合わせた授業運営のヒントをお届けします。
        <br />
        生成したヒントはデジタル教材画面の「指導書」からご確認いただけます。
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={onBack}>
            <BackIcon /> 戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default Guide;
